import { createFileRoute } from "@tanstack/react-router";
import { OutboundVerificationDetailPage } from "@/features/outbound/outbound-verification-detail-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/weryfikacja-wysylek/$id")({
	component: OutboundVerificationDetailPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.weryfikacja-wysylek",
			location.pathname,
		);
	},
});
